export default __webpack_public_path__ + "static/media/reactrouter.f23edf07.png";